import { brands } from 'Constants';

 
export default state => {
  
  if (!state.brandID) {
    state.brandID = brands.ABC;
    return;
  }
  if (brands[state.brandID]) {
    state.brandID = brands[state.brandID];
    return;
  }

 
  if (!state.brandID) {
    state.brandID = brands.ABC;
    return;
  }
};
